import { styled } from "@mui/material";

interface SubTitleTextProps {
  size?: string;
  margin?: string;
}

export const SubTitleText = styled("span")(({ size, margin }: SubTitleTextProps) => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: size || "1rem",
  lineHeight: "1.5rem",
  color: "#1D2939",
  margin: margin || 0,
  padding: 0,
}));
